(() => {
  if (customElements.get('bfd-price-proposal')) return;
  class PriceProposal extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[data-proposal-price]');
      this.error = this.querySelector('[data-proposal-error]');
      this.querySelector('[data-proposal-send]').addEventListener('click', () => this.send());
      this.input.addEventListener('input', () => {
        this.error.hidden = true;
        this.input.removeAttribute('aria-invalid');
      });
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          this.send();
        }
      });
    }
    send() {
      const raw = this.input.value.trim();
      if (!/^\d{1,7}(?:[.,]\d{1,2})?$/.test(raw)) return this.invalid();
      const parts = raw.replace(',', '.').split('.');
      const cents = Number(parts[0]) * 100 + Number((parts[1] || '').padEnd(2, '0'));
      if (!Number.isSafeInteger(cents) || cents <= 0) return this.invalid();
      const formatted = (cents / 100).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      const productUrl = new URL(this.dataset.productUrl);
      const form = document.getElementById(this.dataset.productForm);
      const selected = form?.querySelector('[name="id"]')?.value;
      let variantLine = '';
      try {
        const variants = JSON.parse(this.querySelector('[data-proposal-variants]').textContent);
        const variant = variants.find(item => String(item.id) === String(selected));
        if (variant) {
          productUrl.searchParams.set('variant', variant.id);
          if (variant.title && variant.title !== 'Default Title') variantLine = `\nVariante: ${variant.title}`;
        }
      } catch (_) { /* Product title and canonical URL remain sufficient. */ }
      const text = `Hallo, ich möchte einen Preisvorschlag machen.\n\nArtikel: ${this.dataset.productTitle}${variantLine}\nVorgeschlagener Preis: ${formatted} €\nLink: ${productUrl.href}`;
      const url = `https://wa.me/${this.dataset.whatsapp}?text=${encodeURIComponent(text)}`;
      this.error.hidden = true;
      this.input.removeAttribute('aria-invalid');
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    invalid() {
      this.error.hidden = false;
      this.input.setAttribute('aria-invalid', 'true');
      this.input.focus();
    }
  }
  customElements.define('bfd-price-proposal', PriceProposal);
})();
